__turbopack_context__.v({
  "instagram": "Markdown-module-scss-module__QQKctG__instagram",
  "instagramContainer": "Markdown-module-scss-module__QQKctG__instagramContainer",
  "link": "Markdown-module-scss-module__QQKctG__link",
  "postHeight": "Markdown-module-scss-module__QQKctG__postHeight",
  "reelHeight": "Markdown-module-scss-module__QQKctG__reelHeight",
});
